export const RESET_STATE = 'RESET_STATE';

export const FETCH_LOGIN_DETAILS = 'FETCH_LOGIN_DETAILS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SEND_OTP = 'SEND_OTP';
export const RESEND_OTP = 'RESEND_OTP'
export const OTP_SENT = 'OTP_SENT';
export const OTP_NOT_SENT = 'OTP_NOT_SENT';

export const PASSWORD_RESET = 'PASSWORD_RESET';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';

export const PASSWORD_RESET_FLAG = 'PASSWORD_RESET_FLAG'

export const GET_HISTORY = 'GET_HISTORY';

export const SEND_OTP_LOGIN = 'SEND_OTP_LOGIN';


// WEBPACK FOOTER //
// ./src/actions/actionConstants.js